<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qD7vKY/tc-custom/9781504020015.jpg?1701241888280" alt="This image is the cover for the book King Is Dead"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">King Is Dead
      </h1>
      <p class="bookDescription body article font2">
        <b>Ellery Queen and his father discover a baffling murder on a private island</b><br/><br/> Ellery Queen and his father are meandering through breakfast when their apartment is invaded. Without making a sound, 2 men appear in the Queens’ living room, guns drawn, and proceed to search the place. When they’re done, a 3rd man follows: a paunchy little professor-type who happens to be the brother of a king. King Bendigo doesn’t rule a country, but his control of the international arms trade has made him one of the richest men in the world. It’s not surprising that somebody wants him dead.<br/>  <br/> Bendigo’s brother comes to the Queens to ask them to save the tycoon’s life—but they fail. The king is found dead in a hermetically sealed room, a bullet lodged in his heart. The murder is impossible to solve—that is, for anyone but Ellery Queen.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellery Queen
      </h2>
      
      <p class="authorDescription body article">Ellery Queen was a pen name created and shared by two cousins, Frederic Dannay (1905&ndash;1982) and Manfred B. Lee (1905&ndash;1971), as well as the name of their most famous detective. Born in Brooklyn, they spent forty-two years writing, editing, and anthologizing under the name, gaining a reputation as the foremost American authors of the Golden Age &ldquo;fair play&rdquo; mystery.&#160;Although eventually famous on television and radio, Queen&rsquo;s first appearance came in 1928, when the cousins won a mystery-writing contest with the book that would eventually be published as <i>The Roman Hat Mystery</i>. Their character was an amateur detective who uses his spare time to assist his police inspector uncle in solving baffling crimes. Besides writing the Queen novels, Dannay and Lee cofounded <i>Ellery Queen&rsquo;s Mystery Magazine</i>, one of the most influential crime publications of all time. Although Dannay outlived his cousin by nine years, he retired Queen upon Lee&rsquo;s death. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0139ee92